import styled from "styled-components";
import PricingPlans from "../components/pricingAndEarning/PricingPlans";
import PlanBenefits from "../components/pricingAndEarning/PlanBenefits";
import PlanComparison from "../components/pricingAndEarning/PlanComparison";
import CallToAction from "../components/pricingAndEarning/CallToAction";

const PricingEarningPage = () => {
  return (
    <Wrapper>
      <div className="padding-65 mt-3 mt-md-5 pb-3 pb-md-5 px-4">
        <div className="max-w-800 text-center font-17 my-3 mb-md-4">
          <h2 className="font-40 text-black">Choose How You Earn</h2>
          <p className="mt-4 text-dark-gray ">
            Rent your car to Fleetsimplify, earn every month. Pick a plan that
            works for you.
          </p>
        </div>
        <div className="p-2 section_wrapper text-center py-3 py-lg-5">
          <PricingPlans />
          <PlanBenefits />
          <PlanComparison />
        </div>
      </div>
      <CallToAction />
    </Wrapper>
  );
};

export default PricingEarningPage;

const Wrapper = styled.div`
  background: #f4f8fc;

  .section_wrapper {
    width: 100%;
    max-width: 70rem !important;
    margin: 0 auto;
  }
`;
